export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;
    const TYPE_NAME = "WRONG-ADDRESS-MESSAGE";
    const DATA_TYPE_ATTR_NAME = "data-lg-type";

    var model = MODEL.extend({
        defaults: {
            ...MODEL.prototype.defaults,
            "custom-name":  `C-${TYPE_NAME}`,
            attributes: {
                [DATA_TYPE_ATTR_NAME]:  `C-${TYPE_NAME}`,
            },
            classes: [],
            traits: [
            ].concat(MODEL.prototype.defaults.traits)
        },
        onRender() {

        }

    }, {
        isComponent(el) {
            if (el && el.getAttribute && el.getAttribute(DATA_TYPE_ATTR_NAME) == `C-${TYPE_NAME}`)
                return { type: `C-${TYPE_NAME}` }
        },
    });
    var view = VIEW.extend({

    })

    DOMC.addType(`C-${TYPE_NAME}`, {
        model: model,
        view: view
    });

    BM.add(`B-${TYPE_NAME}`, {
        label:`${TYPE_NAME}`,
        content: {
            type: `C-${TYPE_NAME}`,
        },
        category: "ADVANCE COMPONENT"
    });
}
